import { defaultProps } from 'recompose';

import AddButton from './AddButton';
import Block from './Block';
import ArticleForm from './component';

export default defaultProps({ Block, AddButton })(ArticleForm);
